import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  insurerCoverageAll: [],
  insurerCoverage: {},
  currentPage: 1,
  totalPages: 1,
  rowsPerPage: 10,
  sortBy: "name",
  sortOrder: "asc",
};

const insurerCoverageSlice = createSlice({
  name: "insurerCoverage",
  initialState,
  reducers: {
    setInsurerCoverageAll: (state, action) => {
      state.insurerCoverageAll = action.payload;
    },
    setInsurerCoverage: (state, action) => {
      state.insurerCoverage = action.payload;
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setTotalPages: (state, action) => {
      state.totalPages = action.payload;
    },
    setRowsPerPage: (state, action) => {
      state.rowsPerPage = action.payload;
    },
  },
});

export const {
  setInsurerCoverageAll,
  setInsurerCoverage,
  setCurrentPage,
  setTotalPages,
  setRowsPerPage,
} = insurerCoverageSlice.actions;

export default insurerCoverageSlice.reducer;
